<template>
	<div class="datatable row pos-r">
        <div class="fixed-datatable" v-if="fixedColumns.length" style="background:#e9ecef">
            <table class="table bgc-white table-bordered mB-0 border-right-0 w-a">
                <thead class="thead-light ta-c bdB ">
                    <tr>
                        <th v-for="(column, key) in fixedColumns" 
                            :key="key"
                            :style="{ 'width': column.width + 'px' }"
                            :class="getClasses(column)"
                            @click="sortBy(key)" 
                            rowspan="1" 
                            colspan="1"
                            v-show="column.display">
                            <nobr>{{ column.title }}</nobr>
                        </th>
                    </tr>
                </thead>
            </table>
            <div :style="{ height: bodyClientHeight + 'px' }" class="ov-h fixed-datatable-body">
                <table class="table bgc-white table-bordered mB-0 border-right-0 w-a">
                    <tbody class="fsz-xs">
                        <tr v-for="(value, key) in values" :key="key" :class="{ 'hover-row': hoverRow == key }" @mouseenter="mouseEnter(key)" @mouseleave="mouseLeave()">
                            <td v-for="(column, index) in fixedColumns" :key="index" v-show="column.display" :style="{ 'width': column.width + 'px' }">
                                <slot v-if="column.slot" :data="value" :name="column.name"></slot>
                                <span v-else v-html="getColumnValue(column, value)" :title="getColumnValue(column, value)"></span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
		<button type="submit" class="btn btn-info pull-right btn-sm" @click="showModal()" style="position: fixed; right: 15px; top: 76px; z-index: 9;" v-if="!hideSetting">
			<i class="fa fa-cog"></i> {{$Lang('设置')}}
        </button>
		<div class="datatable-header" :class="{ 'ovY-s': hasScrollY }">
			<table class="table bgc-white table-bordered mB-0" :style="{ 'min-width': allColumnsWidth ? `${allColumnsWidth}px` : '100%' }">
				<thead class="thead-light ta-c">
					<tr class="c-grey-900">
						<th v-if="selection" width="50"><input type="checkbox" :checked="selectionAllStauts" @change="handleSelectionAll($event.target.checked)"></th>
						<th v-for="(column, key) in tableColumns" :width="column.width || 'auto'" :key="key" :class="getClasses(column, true)" v-if="column.visible" @click="sortBy(key)" rowspan="1" colspan="1">
			            	<nobr>{{ column.title }}</nobr>
			            </th>
			        </tr>
			    </thead>
			</table>
		</div>
		<div class="datatable-body" :style="height ? `height: calc(${height} - 171px)` : '' " @scroll.passive="onScroll">
			<div class="alert alert-warning w-100p ta-c mB-0 fsz-xs pT-5 pB-5" v-if="selection && selectionAllStauts && total > CONFIG.PAGE_MAX_ROW">
				<template v-if="selectionAllDataStatus">
					{{ $Lang('您当前选定了全部记录！共计') }} <b class="c-grey-900">{{ total }}</b> {{ $Lang('条。') }}
					<a href="javascript:;" @click="handleSelectionAll(false)">{{$Lang('取消选定')}}</a>
				</template>
				<template v-else>
					{{ $Lang('您当前选定了') }} <b class="c-grey-900">{{ selectionData.length }}</b> {{ $Lang('条记录！') }}
					<a href="javascript:;" @click="handleSelectionAll(false)">{{ $Lang('取消选定') }}</a>&nbsp;&nbsp;
					<a href="javascript:;" @click="handleSelectionAllData()">{{ $Lang('选定全部') }} ({{ total }})</a>
				</template>
			</div>
			<table class="table bgc-white table-bordered mB-0" :style="{'min-width': allColumnsWidth ? `${allColumnsWidth}px` : '100%' }">
				<colgroup>
					<col v-if="selection" width="50">
					<col v-for="(column, key) in tableColumns" :width="column.width || 'auto'" :key="key" v-if="column.visible">
				</colgroup>
			    <tbody class="fsz-xs">
			        <tr v-for="(value, key) in values" :key="key" @mouseenter="mouseEnter(key)" @mouseleave="mouseLeave()" :class="{ 'hover-row': hoverRow == key }">
			            <td v-if="selection"><input type="checkbox" v-model="value.checked" @change="selectionChange()"></td>
			            <td v-for="(column, index) in tableColumns" :key="index" v-if="column.visible">
			            	<slot v-if="column.slot" :data="value" :name="column.name"></slot>
			                <span v-else v-html="getColumnValue(column, value)" :title="getColumnValue(column, value)"></span>
			            </td>
			        </tr>
			    </tbody>
			</table>
		</div>
		<Modal :open="status" @close="showModal()" align="center" animatedEnterClass="fadeIn" animatedLeaveClass="fadeOut">
			<div class="modal-content" style="width: 18rem; max-height:100vh">
            	<div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">{{ $Lang('配置列表项') }}<small class="mL-10">{{ $Lang('拖动可排序') }}</small></h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="showModal()">
                     	<span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body pT-5 pB-5 ovY-a">
                	<ul class="list-group-flush pL-0 column-config">
					  	<li class="list-group-item pT-5 pB-5 checkbox checkbox-info" v-for="(column, index) in tableColumns" :key="index" @dragstart="dragstart(index)" @dragenter="dragenter(index)" @dragend="dragend()" draggable="true" :class="{ 'drag-active': dragIndex == index }">
						    <input type="checkbox" v-model="column.visible" :id="index" @change="columnsChange">
					  		<label class="mB-0" :for="index">&nbsp;&nbsp;{{ column.title }}</label>
					  	</li>
					</ul>
                </div>
                <div class="modal-footer ta-c">
                	<button type="button" class="btn btn-primary" data-dismiss="modal" @click="showModal()">{{this.$Lang('关闭')}}</button>
                </div>
            </div>
		</Modal>
	</div>
</template>
<script>
    import Vue from 'vue'
    import { formatDate } from '@/utils/date'
    import request from '@/utils/request'

	export default {
		name: 'tables',
		props: {
			columns: {
				type: Array,
				required: true
			},
            tableWidth : {
                type: Number,
                default: 0
            },
			values: {
				type: Array,
				required: true
			},
			sortByHandler: {
				type: Function 
			},
			hideSetting: {
                type: Boolean,
                default: false
            },
			selection: {
				type: [Boolean, Function],
				default: false
			},
			total: {
				type: Number 
			},
			height: {
				type: String,
                default: '100vh - 66px'
			},
            columnsInfo: {
                type: Object
            }
		},
		computed: {
			selectionData () {
				return this.values.filter(row => {
					return row.checked
				})
			},
			selectionAllStauts () {
				return this.selectionData.length !== 0 && this.selectionData.length === this.values.length
			}
		},
		mounted () {
            window.addEventListener('resize', this.setHeaderScroll)

            this.getColumns()
		},
		methods: {
			sortBy (key) {
                if (this.tableColumns[key] && this.tableColumns[key].sortable) {
				    this.tableColumns.forEach((cols, index) => {
					    if (key === index && cols.sortable) {
						    cols.sortBy = cols.sortBy === 'default' ? 'asc' : cols.sortBy === 'asc' ? 'desc' : 'asc'
						    if (this.sortByHandler) {
							    this.sortByHandler(cols)
						    }
					    } else {
						    cols.sortBy = 'default'
					    }
				    })
                }
			},
			getClasses (column, type) {
                const classArr = []

                if (column.fixed && type) {
                    classArr.push(`fixed_column_${column.name}`)
                }

				if (column.sortBy) {
                    classArr.push(`sorting_${column.sortBy}`)
                    classArr.push('cur-p')
				}

				return classArr
			},
			showModal () {
				this.status = !this.status
			},
			handleSelectionAll (status) {
				this.selectionAllDataStatus = false
				this.values.forEach(item => {
					this.$set(item, 'checked', status);
				})

				this.selectionChange()
			},
			selectionChange (all) {
				this.selection(all || this.selectionData)
			},
			handleSelectionAllData () {
				this.selectionAllDataStatus = true
				this.selectionChange('all')
			},
			onScroll (e) {
                const bodyEl = this.$el.querySelector('.datatable-body')
                const scrollLeft = bodyEl.scrollLeft
				this.$el.querySelector('.datatable-header').scrollLeft = scrollLeft

                if (this.fixedColumns.length) {
                    this.$el.querySelector('.fixed-datatable-body').scrollTop = bodyEl.scrollTop
                    this.fixedColumns.forEach(column => {
                        if (column.visible) {
                            column.display = scrollLeft > column.offsetLeft
                        }
                    })
                }
			},
			setHeaderScroll () {
				this.$nextTick(() => {
					this.hasScrollY = this.$el.querySelector('.datatable-body').scrollHeight > this.$el.querySelector('.datatable-body').clientHeight

                    this.fixedColumns.forEach(column => {
                        if (column.visible) {
                            const el = this.$el.querySelector(`.fixed_column_${column.name}`)
                            column.offsetLeft = el.offsetLeft
                            column.width = column.width || el.offsetWidth  
                        }
                    })

                    this.bodyClientHeight = this.$el.querySelector('.datatable-body').clientHeight
				})
			},
            getColumnValue (column, value) {
                let columnValue = value[column.name]
                if (column.inTitle && column.inTitle[columnValue]) {
                    return column.inTitle[columnValue]
                }
                if (column.format === 'date' && Number(columnValue) > 0) {
                    columnValue = formatDate(columnValue)
                }
                return columnValue
            },
            getColumns () {
                if (!this.columnsInfo) {
                    let datas = this.columns

                    // 重定义显示value
                    datas.forEach((column, index) => {
                        const hasScopedSlots = Object.keys(this.$scopedSlots).some(name => name === column.name)
                        column.slot = hasScopedSlots
                        if (column.fixed) {
                            Vue.set(datas[index], 'display', false)
                            this.fixedColumns.push(column)
                        }
                    })
                    this.tableColumns = datas;
                    return false
                }

                request.post('platformshop/seller/getTablesDefine', { module_name: this.columnsInfo.module, tabel_name: this.columnsInfo.table, get_type: 'shop' }).then(response => {
                    if (response.data.status === 'succ') {
                        const result = response.data.data
                        const datas = result.columns
                        const config = result.config

                        this.allColumnsWidth = response.data.data.tabel_width || this.tableWidth

                        // 重新定义column
                        datas.forEach((data, index) => {
                            const hasColumn = this.columns.filter(column => column.name === data.name)

                            if (hasColumn.length) {
                                datas[index] = hasColumn[0]
                            }
                        })

                        // 添加column
                        this.columns.forEach(column => {
                            // if (!column.slot) { return false }

                            const slotIndex = column.slotIndex || 0
                            datas.splice(slotIndex, 0, column)
                        })

                        datas.forEach((column, index) => {
                            // 判断是否有字段slot
                            const hasScopedSlots = Object.keys(this.$scopedSlots).some(name => name === column.name)
                            column.slot = hasScopedSlots

                            // 本地设置显示字段
                            if (config && config[column.name]) {
                                column.visible = config[column.name].visible
                                column.sort = config[column.name].sort
                            }  

                            if (column.fixed) {
                                Vue.set(datas[index], 'display', false)
                                this.fixedColumns.push(column)
                            }

                            column.sort = typeof column.sort === 'undefined' ? index : column.sort
                        })

                        this.tableColumns = datas
                        this.columnsSort()
                        this.$emit('getColumnsData', this.tableColumns)
                    } else {
                        this.$Message.danger(response.data.msg)
                    } 
                }).catch((...error) => {
                    this.jsErrorHandler(...error)
                })
            },
            mouseEnter (index) {
                this.hoverRow = index
            },
            mouseLeave () {
                this.hoverRow = -1
            },
            columnsChange () {
                const columns = []

                this.tableColumns.forEach(column => {
                    if (!column.visible) {
                        columns.push(column.name)
                    }
                })

                this.postConfig()
            },
            dragstart (index) {
                this.dragIndex = index
            },
            dragenter (index) {
                if (this.dragIndex === index) { return false }

                const pre = this.tableColumns[index].sort
                const active = this.tableColumns[this.dragIndex].sort

                this.tableColumns[index].sort = active
                this.tableColumns[this.dragIndex].sort = pre

                this.columnsSort()

                this.dragIndex = index
            },
            dragend () {
                this.dragIndex = -1

                this.postConfig()
            },
            postConfig () {
                const data = {}
                this.tableColumns.forEach(column => {
                    data[column.name] = {
                        sort: column.sort,
                        visible: column.visible
                    }
                })

                request.post('platformshop/seller/setTablesDefine', {
                    name: `${this.columnsInfo.module}_${this.columnsInfo.table}`,
                    columns: JSON.stringify(data),
                    _LoaderConfig: false
                }).then(response => {})
            },
            columnsSort () {
                this.tableColumns.sort((a, b) => {
                    return a.sort - b.sort
                })
            }
		},
		watch: {
			values (val) {
				this.setHeaderScroll()
			},
			tableColumns: {
				handler: function (val) {
					this.setHeaderScroll()
				},
				deep: true
			},
            tableWidth (val) {
                if (val) {
                    this.allColumnsWidth = val
                }
            }
		},
		data () {
			return {
                tableColumns: [],
				status: false,
				allColumnsWidth: 0,
				selectionAllDataStatus: false,
				headTop: 0,
				hasScrollY: false,
                fixedColumns: [],
                bodyClientHeight: 0,
                hoverRow: -1,
                dragIndex: -1
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/table/table.vue